import { IAdminIngredientsSearchResult } from '@interfaces/adminIngredients';
import { IFetchListRequestPayload } from '@interfaces/common';

import { apiUrls } from './urls';
import { post } from './utils';

export const adminSearchIngredients = (payload: IFetchListRequestPayload) =>
  post<IAdminIngredientsSearchResult>(apiUrls.adminInquiries.ingredientsSearch, payload);
